(function() {
    'use strict';

    angular.module('app').controller('CheckoutController', CheckoutController);

    function CheckoutController(
        $scope,
        $http,
        $window,
        $timeout,
        $modal,
        AddressFactory,
        FormError,
        CartFactory,
        OrderFactory,
        CartCouponCodeFactory,
        InternationalRatesFactory,
        MetadataFactory,
        HubspotFactory,
        TaxJarFactory,
        Upload
    ) {
        $scope.order = {
            items: CartFactory.items,
            user : {billing_address: {}},
            shipping_address: {},
            paymentMethod: 'plastic',
            viewTotal: 0,
            taxRate: 0,
            sessionID: 0,
            orderTotal:0,
            filenames: [],
            taxExempt: false,
            taxID: ''
        };
        $scope.calcCartQty = CartFactory.cartQtyCallback;
        $scope.cartTotal = CartFactory.cartTotal;
        $scope.fifteenYears = fifteenYears;
        $scope.validate = validate;
        $scope.submitCheckout = submitCheckout;
        $scope.submitPaypal = submitPaypal;
        $scope.createOrder = createOrder;
        $scope.order.creditCard = {};
        $scope.error = false;
        $scope.shippingInfo = null;
        $scope.serviceSplit = serviceSplit;
        $scope.addShippingPrice = addShippingPrice;
        var shippingPrice = 0;
        $scope.shippingLoading = false;
        $scope.paypalMissing = false;
        $scope.paypalPaid = false;
        $scope.paymentAttempts = 0;
        $scope.submitOnHold = submitOnHold;
        $scope.sendTagEvent = sendTagEvent;
        $scope.checkoutProcessStageEvents = {'reachedCheckout' : false, 'reachedPayment' : false};
        $scope.sendTagEvent('reachedCheckout');
        $scope.encourageLogin = false;
        //$scope.uspsValidation = uspsValidation;
        $scope.sendToForm = sendToForm;
        $scope.closeForm = closeForm;
        $scope.showTimesUserAsked = 0;
        $scope.order.shipping_address.country = 'United States';
        $scope.formData = '';
        $scope.ccCorrect = ccCorrect;
        $scope.hubspotUpdate = hubspotUpdate;
        $scope.shippingObj = {};
        $scope.shippingObj.shippingModel = false;
        $scope.process = process;
        $scope.calcCartTax = calcCartTax;
        $scope.counter = 0;
        $scope.updateUI = updateUI;
        $scope.uploadNewFile = uploadNewFile;
        $scope.uploadFileData = '';
        $scope.getInput = getInput;

        $scope.$watch('order.shipping_address', onShippingAddressChange, true);
        $scope.$watch('order.taxExempt', onTaxExemptChange);

        function onTaxExemptChange(oldValue, newValue) {
            if (oldValue !== newValue) {
                calcCartTax();
            }
        }


        function sendTagEvent(stage) {
            if (!$scope.checkoutProcessStageEvents[stage]) {
                gtag('event', stage, {'event_category': 'Checkout'});
                $scope.checkoutProcessStageEvents[stage] = true;
            }
        }

        function ccCorrect() {
            var getNum = '';
            if($scope.order.creditCard.number !== undefined)
            {
                var number = $scope.order.creditCard.number;
                if(number) {
                    getNum = number.replace(/[\-\s]{0,16}/, '');
                }
                var fix = getNum.replace(/^\s*|\s*$/,"");
                $scope.order.creditCard.number = '';
                $scope.order.creditCard.number = fix;
            }
        }

        function calcCartTax()
        {
            var order = $scope.order;
            var state = order.shipping_address.state;
            var total = order.orderTotal = CartFactory.cartTotal();
            var email = $scope.order.user.email;
            $scope.taxExempt = order.taxExempt;
            if($scope.taxExempt)
            {
                $scope.order.orderTotal = total;
                $scope.order.taxTotal = 0.00;
            } else {
                TaxJarFactory.checkNexus({state:state, order:order, email:email}).$promise.then(addCalc);
            }
        }

        function getInput()
        {
            var taxID = $('#taxID');
            var $this = $(this);
            var input = taxID.val();
            input = input.replace(/[a-zA-Z\W\s\._\-]+/g, '');
            var split = 4;
            var chunk = [];
            for(var i = 0, len = input.length; i < len; i += split)
            {
                split = (i <= 2 && i <= 1)? 2 : 7;
                chunk.push(input.substr(i,split));
            }
            taxID.val(function(){
                return  chunk.join("-");
            });
        }

        function addCalc(data)
        {
            if(data[0] !== undefined) {
                $scope.order.taxRate = data[0].rate;
                var total = data[0].order_total_amount;
                // The amount of taxes to collect
                var amt = data[0].amount_to_collect;
                $scope.order.taxTotal = amt;
                $scope.order.orderTotal = total + amt;
            }
        }

        //init metadata
        MetadataFactory.get({'models[]': [
                'Shipping'
            ]}).$promise.then(loadAfterMetadata);

        $('.o-loading').fadeOut('fast');
        $(document).foundation();

        // Prevent the return key (13) from submitting the form in the auto complete field
        $('#autocomplete').keypress(function(e) {
            if (e.which == '13') {
                e.preventDefault();
            }
        });

        function uploadNewFile(file, errFiles, type) {
            $scope.uploadFileData = file;
            $scope.fileUploadErrFile = errFiles[0];

            if (file) {
                file.upload = Upload.upload({
                    url: 'FilesCheck',
                    method: 'POST',
                    file: file,
                    sendFieldsAs: 'form'
                });

                file.upload.then(function (response) {
                        $timeout(function () {
                            file.result = response.data;
                            $scope.order.filenames.push(type,response.data.fileName);
                        });
                    },

                    function (response) {
                        $scope.fileUploadErrFile = response.statusText;
                    },

                    function (evt) {
                        file.progress = Math.min(100, parseInt(100.0 *
                            evt.loaded / evt.total));
                    }
                );
            }
        }

        function process()
        {
            validate();
            //uspsValidation();
            calcCartTax();
        }

        function hubspotUpdate()
        {
            if(typeof $scope.order.user.email === 'undefined' || $scope.order.user.email.length === 0 )
                return;

            else if(typeof $scope.order.shipToName !== 'undefined') {
                if ($scope.order.shipToName.length !== 0) {
                    HubspotFactory.update_wname({
                        email: $scope.order.user.email,
                        name: $scope.order.shipToName,
                        amt: CartFactory.cartTotal().toFixed(2),
                        phone: $scope.order.shipToPhone
                    });
                }
            }
            else{
                HubspotFactory.update({email:$scope.order.user.email, amt:CartFactory.cartTotal().toFixed(2)});
            }
        }

        function sendToForm() {
            var parser = new DOMParser();
            var xmlDoc2 = parser.parseFromString($scope.formData,"text/xml");
            var Eaddress = xmlDoc2.getElementsByTagName("Address2")[0];
            var address = Eaddress.innerHTML;

            if(xmlDoc2.getElementsByTagName("Address1")[0] !== undefined)
            {
                var Eaddress2 = xmlDoc2.getElementsByTagName("Address1")[0];
                var address2 = Eaddress2.innerHTML;
            }

            var Ecity = xmlDoc2.getElementsByTagName("City")[0];
            var city = Ecity.innerHTML;
            var Estate = xmlDoc2.getElementsByTagName("State")[0];
            var state = Estate.innerHTML;
            var Ezip1 = xmlDoc2.getElementsByTagName("Zip5")[0];
            var zip1 = Ezip1.innerHTML;
            var Ezip2 = xmlDoc2.getElementsByTagName("Zip4")[0];
            var zip2 = Ezip2.innerHTML;

            checkField(1,$scope.order.shipping_address.line1, address);

            if(address2 === undefined)
            {
                checkField(5,$scope.order.shipping_address.line2, address2);
            }

            checkField(2,$scope.order.shipping_address.city, city);
            checkField(3,$scope.order.shipping_address.state, state);
            checkField(4,$scope.order.shipping_address.postalCode, zip1, zip2);

            $scope.showTimesUserAsked++;

            $.magnificPopup.close();
        }

        function closeForm()
        {
            $.magnificPopup.close();
        }

        function updateUI()
        {
            calcCartTax();
        }

        function checkField($num, $field, xml1)
        {
            if($field !== xml1)
            {
                switch($num)
                {
                    case 1:
                        $scope.order.shipping_address.line1 = xml1;
                        break;
                    case 2:
                        $scope.order.shipping_address.city = xml1;
                        break;
                    case 3:
                        $scope.order.shipping_address.state = xml1;
                        break;
                    case 4:
                        $scope.order.shipping_address.postalCode = xml1;
                        break;
                    case 5:
                        $scope.order.shipping_address.line2 = xml1;
                        break;

                    default:
                        break;
                }

            }
        }

        /**
         * Encapsulate the request to fetch the current order.
         */
        function loadAfterMetadata(index) {
            CartFactory.couponRefresh();
            $scope.countries = [];
            angular.forEach(index.Shipping.countries, function(value, key) {
                $scope.countries.push({'abbreviation': key, 'name': value});
            }, $scope.countries);
            if($scope.cartTotal() === 0) {
                $scope.order.paymentMethod = 'free';
            }
        }

        function addShippingPrice(totalPrice){
            removeShippingPrice();
            if(totalPrice !== null &&
                typeof totalPrice !== 'undefined'){
                $scope.shippingLoading = false;
                shippingPrice = totalPrice;
                var perBand = totalPrice/$scope.calcCartQty();
                angular.forEach($scope.order.items, function(item){
                    item.price += perBand;
                });
            }else {
                $scope.shippingLoading = false;
            }
        }

        function removeShippingPrice(){
            var perBand = shippingPrice/$scope.calcCartQty();
            angular.forEach($scope.order.items, function(item){
                item.price -= perBand;
            });
            shippingPrice = 0;
        }

        /**
         * Checks if the form field has a valid error that should be shown.
         *
         * @param {Object} form           The form object to check for error.
         * @param {string} fieldName      The field name to check if its valid or not.
         * @param {string} validationRule The rule to be used to check the field validation.
         * @param {string} message        The message to be displayed if the field has an error.
         * @return {boolean} If the field should show error.
         */
        $scope.checkError = function(form, fieldName, validationRule, message) {
            return FormError.hasError(form, fieldName, validationRule, message);
        };

        $scope.activeAccount = function(email) {
            $http.post('checkuser', {email: email})
                .then(function (response) {
                    $scope.encourageLogin = response.data.exists;
                }.bind($scope));
        };

        function onShippingAddressChange(newValue, oldValue) {
            if (newValue === oldValue) {
                return;
            }

            var country = $scope.order.shipping_address.country !== '' &&
                $scope.order.shipping_address.country !== null &&
                typeof $scope.order.shipping_address.country !== 'undefined';

            var line1 = $scope.order.shipping_address.line1 !== '' &&
                $scope.order.shipping_address.line1 !== null &&
                typeof $scope.order.shipping_address.line1 !== 'undefined';

            var city = $scope.order.shipping_address.city !== '' &&
                $scope.order.shipping_address.city !== null &&
                typeof $scope.order.shipping_address.city !== 'undefined';

            var state = $scope.order.shipping_address.state !== '' &&
                $scope.order.shipping_address.state !== null &&
                typeof $scope.order.shipping_address.state !== 'undefined';

            var zip = $scope.order.shipping_address.postalCode !== '' &&
                $scope.order.shipping_address.postalCode !== null &&
                typeof $scope.order.shipping_address.postalCode !== 'undefined';

            if (country && line1 && city && state && zip) {
                calcCartTax();

                if ($scope.order.shipping_address.country === "United States") {
                    $scope.shippingInfo = null;
                    removeShippingPrice();
                } else {

                    var total = 0;
                    var cost = 0;
                    var deliveryDate = '';
                    angular.forEach($scope.order.items, function (item) {
                        if (item.quantity >= 100) {
                            total += (item.quantity + item.promotionalQuantity);
                        } else {
                            total += item.quantity;
                        }
                        cost += (item.price * item.quantity);
                        deliveryDate = item.custom_fields.delivery_date.value;
                    });

                    $scope.shippingLoading = true;
                    processInternationalShippingRates(total, cost.toFixed(2), deliveryDate);
                }
            }


        }

        function syncAddresses() {
            if ($scope.separateBilling) {
                return;
            }

            $scope.order.user.name = $scope.order.shipToName;
            $scope.order.user.company = $scope.order.shipToCompany;
            $scope.order.user.phone = $scope.order.shipToPhone;
            $scope.order.user.billing_address.line1 = $scope.order.shipping_address.line1;
            $scope.order.user.billing_address.line2 = $scope.order.shipping_address.line2;
            $scope.order.user.billing_address.city = $scope.order.shipping_address.city;
            $scope.order.user.billing_address.state = $scope.order.shipping_address.state;
            $scope.order.user.billing_address.postalCode = $scope.order.shipping_address.postalCode;
            $scope.order.user.billing_address.country = $scope.order.shipping_address.country;
        }

        function serviceSplit(service){

            var parsedService;
            parsedService = service.split(/(?=[A-Z])/).join(' ');
            return parsedService.replace('Non Doc','');
        }

        /**
         * Creates an object with 15 years starting from this year.
         * @return {object}
         */
        function fifteenYears() {

            var date = new Date();
            var yyyy = date.getFullYear();
            var yy = yyyy.toString().substr(2,2);
            var years = {};
            for (var y = 0; y < 15; y++) {
                years[yy] = yyyy;
                yyyy++;
                yy++;
            }
            return years;
        }

        /**
         * Checks if the form is valid and indicates any errors.
         *
         * @returns {boolean} True if the checkout form is valid. False if not.
         */
        function validate() {
            $scope.checkoutForm.$setSubmitted();
        }

        function submitCheckout() {
            // Make sure form is validated before creating order on server
            if ($scope.checkoutForm.$valid) {
                grecaptcha.ready(function() {
                    grecaptcha.execute(window.__grecaptcha_key, {action: 'submit'}).then(onCaptchaSuccess);
                });
            }
        }

        function onCaptchaSuccess(token) {
            $scope.order['g-recaptcha-response'] = token;

            CartCouponCodeFactory.isInactive().$promise.then(inactiveCoupon);

            function inactiveCoupon(inactiveBool){
                if(inactiveBool == 'true') {
                    $scope.couponFailed = true;
                    CartFactory.inactiveCoupon();
                    buttonReset();
                } else if (
                    $scope.order.paymentMethod === 'paypal' &&
                    ($scope.order.payment_method_nonce === '' ||
                    typeof $scope.order.payment_method_nonce == 'undefined')
                ) {
                    $scope.paypalMissing = true;
                } else {
                    if($scope.cartTotal() === 0){
                        $scope.order.paymentMethod = 'free';
                    }

                    createOrder();
                    buttonLoading();
                }
            }
        }

        /**
         * Submits a paypal order for payment
         */
        function submitPaypal() {
            $scope.paypalPaid = true;
            submitCheckout();
        }

        function buttonLoading() {
            $('.js-checkout-submit').removeClass('fa-lock').addClass('disabled fa-refresh ffab-spin');
        }

        function buttonReset() {
            $('.js-checkout-submit').addClass('fa-lock').removeClass('disabled fa-refresh ffab-spin');
        }

        function submitOnHold() {
            $('.js-checkout-submit').removeClass('fa-lock').addClass('disabled fa-refresh ffab-spin');
            $scope.order.paymentMethod = 'on_hold';
            createOrder();
        }

        function createOrder() {
            syncAddresses();
            var cartDiscount = CartFactory.calcCartDiscount();
            //make sure we have the updated totals from additions and removals
            //from cart
            var total = CartFactory.cartTotal();

            $scope.order.orderTotal = total;

            if(!$scope.order.taxExempt)
            {
                $scope.order.orderTotal = total + (total * $scope.order.taxRate);
            }
            $scope.order.subTotal = CartFactory.subTotal();

            if(cartDiscount !== null){
                $scope.order.discount_value = cartDiscount;
            }

            $scope.order.creditCard.cardholderName = $scope.order.user.name;

            OrderFactory.save($scope.order, onCreateSuccess, onCreateError);

        }

        function onCreateSuccess(response, headerGetterFunction) {
            HubspotFactory.delete({email:$scope.order.user.email});
            $window.location = headerGetterFunction('Location');
        }

        function onCreateError(response) {
            if(response.status == '503') {
                // Order timed out. Don't collect payment, but display indication of error.
                hidePayment();
            } else {
                // Some other error. Check to see if payment was made.
                OrderFactory.paymentMade().$promise.then(paymentMade);
                $scope.error = response.data;
            }

            function paymentMade(paymentBool){
                if(paymentBool == 'true'){
                    hidePayment();
                }else{
                    $scope.paypalPaid = false;
                    $scope.hidePayment = false;
                    $scope.paymentAttempts ++;
                    buttonReset();
                }
            }

            function hidePayment() {
                $scope.hidePayment = true;
                $('.js-checkout-submit').addClass('hide');
            }
        }

        function processInternationalShippingRates(qty, cost, deliveryDate) {
            if($scope.order.shipping_address.country !== 'United States') {
                InternationalRatesFactory.internationalShip({
                    quantity: qty,
                    shipping: $scope.order.shipping_address,
                    name: $scope.order.shipToName,
                    company: $scope.order.shipToCompany,
                    value: cost,
                    shipDate: deliveryDate
                }).$promise.then(onProcessInternationalShippingRatesSuccess);
            }
        }

        function onProcessInternationalShippingRatesSuccess(index) {
            if($scope.order.shipping_address.country){
                $scope.shippingInfo = index;
                $scope.addShippingPrice(index.rate);
            }
        }
    }

})();
